var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid mt-3"},[_c('b-nav',{staticClass:"d-none",attrs:{"tabs":"","justified":""}},[_c('b-nav-item',{attrs:{"to":'/reports/orders',"active":""}},[_vm._v("Orders")])],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }